module.exports = __webpack_public_path__ + "img/eres_8_steps.523f19a7.jpg";